import { useRef } from 'react';

export function areArraysShallowEqual<T>(
  previous: readonly T[] | undefined,
  next: readonly T[] | undefined
) {
  if (previous === next) return true;
  if (!previous || !next) return previous === next;
  if (previous.length !== next.length) return false;

  return previous.every((value, index) => Object.is(value, next[index]));
}

export function getShallowStableArray<T>(
  previous: readonly T[] | undefined,
  next: readonly T[] | undefined
) {
  return areArraysShallowEqual(previous, next) ? previous : next;
}

export function useShallowStableArray<T>(value: readonly T[] | undefined) {
  const ref = useRef(value);

  ref.current = getShallowStableArray(ref.current, value);

  return ref.current;
}
